export class IdentificationTypeData {
    private identificationTypeList: string[] = ["National ID", "Driving License", "Passport"];
    public getIdentificationTypeList(): Array<string> {
        return this.identificationTypeList;
    }
}
